export const UPDATE_POP_UP_CHILD = 'UPDATE_POP_UP_CHILD' as const;
export const UPDATE_IS_SHOWN = 'UPDATE_IS_SHOWN' as const;
export const CLEAR_POP_UP = 'CLEAR_POP_UP' as const;
